import React from "react";
import { useTranslation } from 'react-i18next';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

export default function Copyright() {
    const { t } = useTranslation();

    return (
        <Typography variant="body2" color="textSecondary" align="center">
            <Link color="inherit" href={t('WebsiteURL')}>
                {t('Copyright', {date: new Date().getFullYear()})}
            </Link>
        </Typography>
    );
}